import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core';

import t from '../../utils/lang'

const styles = theme => ({
  root: {
    display: 'flex',
    gap: '32px'
  }
});

const ParkingInputs = props => {
  const { i18n, classes, proposalSubmitted, parkings } = props;

  const handleChange = (field, value) => {
    props.handleUpdate(field, value);
  }

  return <div className={classes.root}>
    <TextField
      label={i18n.underground}
      defaultValue={parkings && parkings.underground}
      onChange={e => handleChange('underground', e.target.value)}
      margin="normal"
      disabled={proposalSubmitted}
    />
    <TextField
      label={i18n.surface}
      defaultValue={parkings && parkings.surface}
      onChange={e => handleChange('surface', e.target.value)}
      margin="normal"
      disabled={proposalSubmitted}
    />
  </div>
}

function mapStateToProps({ rfpData }) {
  const { id, lang, statusId, parkings } = rfpData

  return {
    rfpId: id,
    i18n: t[lang],
    parkings,
    proposalSubmitted: statusId === 3
  }
}

export default connect(mapStateToProps)(withStyles(styles)(ParkingInputs))


// WEBPACK FOOTER //
// ./src/components/CommercialTerms/ParkingInputs.js